import React from 'react'
import Slider from 'react-slick'

import classNames from 'classnames'
import useIsTablet from '../../modules/hooks/common/useIsTablet'
import TabScrollNavsLight from '../TabScrollNavsLight'
import SliderNextBtn from '../common/icons/SliderNextBtn'
import SliderPrevBtn from '../common/icons/SliderPrevBtn'
interface SquareTabsSliderType {
  tabs: Array<any>
  md?: boolean
  lg?: boolean
  xl?: boolean
  isModal?: boolean
  // alignCenter?: boolean
  activeId: number
  setActiveId: any
  arrowIcon?: boolean
  tabLength?: any
  children?: any
}

const SquareTabsSlider: React.FC<SquareTabsSliderType> = ({
  // alignCenter,
  tabs,
  md,
  lg,
  xl,
  children,
  activeId,
  setActiveId,
  arrowIcon,
  tabLength,
  isModal,
}) => {
  const [isTablet, setIsTablet] = useIsTablet()

  return (
    <div>
      <TabScrollNavsLight
        activeId={activeId}
        setActiveId={setActiveId}
        data={tabs}
        md={md}
        xl={xl}
        lg={lg}
        arrowIcon={arrowIcon}
        isModal={isModal}
      />
      <div
        className={classNames({
          'justify-content-center': true,
        })}
      >
        {!isTablet && (
          <Slider
            // dots={false}
            slidesToShow={isTablet ? 1 : tabLength ? tabLength : 4}
            slidesToScroll={isTablet ? 1 : tabLength ? tabLength : 4}
            // infinite={true}
            draggable={false}
            lazyLoad={'ondemand'}
            nextArrow={<SliderNextBtn />}
            prevArrow={<SliderPrevBtn />}
            className="triple-slider"
          >
            {children}
          </Slider>
        )}
        {isTablet && children}
      </div>
    </div>
  )
}

export default SquareTabsSlider
